// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3dBNb","col":"styles_col__2cnxM"};